export default "__VITE_ASSET__DyhphRiM__"